import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const InformacionGeneral = ({
    customerdetails,
    editar,
    editando,
    register,
    errors,
    ordenes,
    soporte
}) => {
    return (
        <Card>
            {editando ? (
                <div
                    className="w-100 d-flex justify-content-center align-items-center"
                    style={{ padding: 20 }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: 1200,
                            background: "#transparent",
                            borderRadius: 8,
                            border: "1px solid #e3e3e3",
                            boxShadow: "0 2px 8px #0001",
                            padding: 20,
                        }}
                    >
                        {/* Skeleton del Header */}
                        <Row className="mb-4">
                            <Col xs="auto" className="mt-2">
                                <Skeleton width={70} height={70} />
                            </Col>
                            <Col>
                                <Skeleton height={24} width="60%" className="mb-2" />
                                <Skeleton height={24} width="70%" className="mb-2" />
                                <Skeleton height={18} width="80%" className="mb-3" />
                            </Col>
                            <Col lg={6} sm={12} xs={12} md={12}>
                                <Row className="g-0">
                                    <Col xs={2} md={2}>
                                        <Skeleton width={48} height={48} />
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <Skeleton height={16} width="80%" className="mb-1" />
                                        <Skeleton height={20} width="90%" className="mb-1" />
                                        <Skeleton height={12} width="70%" />
                                    </Col>
                                    <Col xs={2} md={2}>
                                        <Skeleton width={48} height={48} />
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <Skeleton height={16} width="80%" className="mb-1" />
                                        <Skeleton height={20} width="90%" className="mb-1" />
                                        <Skeleton height={12} width="70%" />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <hr style={{ borderColor: "#e3e3e3" }} />

                        <Row>
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Skeleton height={10} className="mb-2" />
                                </div>
                                {[1].map((i) => (
                                    <div
                                        key={i}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "6px 0",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <Skeleton height={14} width="85%" />
                                        </div>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </div>
                </div>
            ) : (
                <>
                    <Card.Header>
                        <Row>
                            <Col xs="auto" className="mt-2">
                                <h6 className="text-uppercase text-600">
                                    <img src="/img/cliente70.png" alt="Cliente" />
                                </h6>
                            </Col>
                            <Col>
                                <h5 className="mb-2">
                                    {editar ? (
                                        <>
                                            <Form.Control
                                                type="hidden"
                                                defaultValue={customerdetails.idClienteAkasia}
                                                {...register("idClienteAkasia")}
                                            />
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                autoComplete="off"
                                                onKeyUp={(event) => {
                                                    event.target.value = event.target.value.toUpperCase()
                                                }}
                                                defaultValue={customerdetails.vNombre}
                                                isInvalid={!!errors.vNombre}
                                                {...register("vNombre", {
                                                    required: 'El nombre del cliente es requerido',
                                                    maxLength: 100,
                                                    minLength: 1
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vNombre && errors.vNombre.message}
                                            </Form.Control.Feedback>
                                        </>
                                    ) : (
                                        customerdetails.vNombre
                                    )}
                                </h5>
                                <h5 className="mb-2">
                                    {editar ? (
                                        <>
                                            <Form.Label>Apellidos</Form.Label>
                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                onKeyUp={(event) => {
                                                    event.target.value = event.target.value.toUpperCase()
                                                }}
                                                defaultValue={customerdetails.vApellidos}
                                                isInvalid={!!errors.vApellidos}
                                                {...register("vApellidos", {
                                                    required: 'Los apellidos son requeridos',
                                                    maxLength: 100,
                                                    minLength: 1
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vApellidos && errors.vApellidos.message}
                                            </Form.Control.Feedback>
                                        </>
                                    ) : (
                                        customerdetails.vApellidos
                                    )}
                                </h5>
                                <h6>
                                    {editar ? (
                                        <>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                defaultValue={customerdetails.vEmail}
                                                isInvalid={!!errors.vEmail}
                                                {...register("vEmail", {
                                                    required: 'El email es requerido',
                                                    maxLength: 120,
                                                    minLength: 5,
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                        message: "Email incorrecto."
                                                    }
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vEmail && errors.vEmail.message}
                                            </Form.Control.Feedback>
                                        </>
                                    ) : (
                                        <a href={"mailto:" + customerdetails.vEmail}>{customerdetails.vEmail}</a>
                                    )}
                                </h6>
                            </Col>
                            <Col lg={6} sm={12} xs={12} md={12} className="g-3">
                                <Row className="g-0">
                                    <Col xs={2} md={2}>
                                        <img src="/img/ventas48.png" alt="Ventas" />
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <h6 className="pb-1 text-700">Ventas</h6>
                                        <p className="font-sans-serif lh-1 mb-1 fs-2">
                                            ${parseFloat(customerdetails.dTotalVenta).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })} MXN
                                        </p>
                                        <div className="d-flex align-items-center">
                                            <h6 className="fs--1 text-500 mb-0">{ordenes.length} compras</h6>
                                        </div>
                                    </Col>
                                    <Col xs={2} md={2}>
                                        <img src="/img/soporte48.png" alt="Soporte" />
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <h6 className="pb-1 text-700">Soporte</h6>
                                        <p className="font-sans-serif lh-1 mb-1 fs-2">
                                            {soporte.length > 0 ? soporte[0].iMinutos : "0"} min
                                        </p>
                                        <div className="d-flex align-items-center">
                                            <h6 className="fs--1 text-500 mb-0">
                                                {soporte.length > 0 ? soporte[0].iNumTickets : "0"} tickets
                                            </h6>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="border-top fs--1">
                        {!editar && (
                            <>
                                <Row>
                                    <Col lg={6}>
                                        <Flex>
                                            <FontAwesomeIcon
                                                icon="user"
                                                className="text-success me-2"
                                                transform="down-5"
                                            />
                                            <div className="flex-1">
                                                El cliente fue registrado el &nbsp;
                                                <SoftBadge bg='primary' className='me-2'>
                                                    {customerdetails.reg_desde}
                                                </SoftBadge> a las &nbsp;
                                                <SoftBadge bg='primary' className='me-2'>
                                                    {customerdetails.reg_desde_hora}
                                                </SoftBadge> por &nbsp;
                                                <SoftBadge bg='success' className='me-2'>
                                                    {customerdetails.vCreatedUser}
                                                </SoftBadge>.
                                            </div>
                                        </Flex>
                                        <Flex>
                                            <FontAwesomeIcon
                                                icon="clock"
                                                className="text-primary me-2"
                                                transform="down-5"
                                            />
                                            <div className="flex-1">
                                                Antiguedad: {customerdetails.antiguedad} d&iacute;as.
                                            </div>
                                        </Flex>
                                        {customerdetails.vUpdatedUser && (
                                            <Flex>
                                                <FontAwesomeIcon
                                                    icon="user"
                                                    className="text-primary me-2"
                                                    transform="down-5"
                                                />
                                                <div className="flex-1">
                                                    La &uacute;ltima modificaci&oacute;n la realiz&oacute;:&nbsp;
                                                    <SoftBadge bg='success' className='me-2'>
                                                        {customerdetails.vUpdatedUser}
                                                    </SoftBadge>
                                                </div>
                                            </Flex>
                                        )}
                                        <p>{customerdetails.vDescripcion}</p>
                                    </Col>
                                    <Col className="end"></Col>
                                </Row>
                            </>
                        )}
                    </Card.Body>
                </>
            )}
        </Card>
    );
};

InformacionGeneral.propTypes = {
    customerdetails: PropTypes.shape({
        idClienteAkasia: PropTypes.number.isRequired,
        vNombre: PropTypes.string,
        vApellidos: PropTypes.string,
        vEmail: PropTypes.string,
        dTotalVenta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        reg_desde: PropTypes.string,
        reg_desde_hora: PropTypes.string,
        vCreatedUser: PropTypes.string,
        antiguedad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        vUpdatedUser: PropTypes.string,
        vDescripcion: PropTypes.string
    }).isRequired,
    editar: PropTypes.bool.isRequired,
    editando: PropTypes.bool.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    ordenes: PropTypes.array.isRequired,
    soporte: PropTypes.array.isRequired
};

export default InformacionGeneral;
